import { reactLocalStorage } from "reactjs-localstorage";

/**
 * Retrieve the first added check-in object in the queue
 * resave the current queue without the popped object.
 */
const current = () => {
	let checkinQueue = getQueue();
	if (checkinQueue.length) {
		const currentObj = checkinQueue.pop();
		saveQueue(checkinQueue);
		return currentObj;
	}
	return false;
};

/**
 * Add a new check-in object to the queue if it doesn't already exist.
 * 
 * @param {*} checkinObj 
 */
const add = checkinObj => {
	let checkinQueue = getQueue();
	if (!isQueued(checkinObj)) {
		checkinQueue.unshift(checkinObj);
		return saveQueue(checkinQueue);
	}
	return checkinObj;
};

/**
 * Setup check-in queue if one does not exist in local storage.
 */
const setup = () => {
	const queue = reactLocalStorage.get("checkin-queue", false);
	if (!queue) {
		reactLocalStorage.setObject("checkin-queue", []);
	}
};

/**
 * Check if a check-in object is currently in the queue.
 * 
 * @param {*} checkinObj 
 */
const isQueued = checkinObj => {
	const queue = getQueue();
	const found = queue.find(function(queued) {
		const { memberId, classId, classDate } = queued;
		const obj = this[0];
		return (
			memberId === obj.memberId &&
			classId === obj.classId &&
			classDate === obj.classDate
		);
	}, [checkinObj]);
	return found;
};

/**
 * Save queue to local storage.
 * 
 * @param {*} queue 
 */
const saveQueue = queue => {
	return reactLocalStorage.setObject("checkin-queue", queue);
};

/**
 * Get checkin queue from local storage.
 */
const getQueue = () => {
	const queueCheck = reactLocalStorage.get("checkin-queue", false);
	let queue = [];
	if (queueCheck) {
		queue = reactLocalStorage.getObject("checkin-queue");
	}
	return queue;
};

export default {
	setup,
	add,
	current
};


// WEBPACK FOOTER //
// ./src/helpers/checkinQueue.js